import { getAccountNumber } from '@interfaces/account';
import { formatPercentValue } from '@utils/moneyFormatting';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import {
  cellFraction,
  matrixRows,
  placeholderPayload,
} from './placeholderMatrix';
import type { AccountAllocationGridProp } from './types';

const EN_DASH = '–';

export const AccountAllocationGrid = ({
  report,
  onSave,
  readOnly = false,
}: AccountAllocationGridProp) => {
  const { t } = useTranslation();

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              {t('components:accountAllocationGrid.fundColumn')}
            </TableCell>
            {report.subAccounts.map((account) => (
              <TableCell key={account.id}>
                {getAccountNumber({
                  id: account.subAccount.account.id,
                  custodianAccountNumber:
                    account.subAccount.account.custodianAccountNumber,
                })}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {matrixRows(report).map((row) => (
            <TableRow key={row.financialProduct.id}>
              <TableCell>
                {row.financialProduct.ticker ?? row.financialProduct.id}
              </TableCell>
              {report.subAccounts.map((account) => {
                const fraction = cellFraction(account, row);
                return (
                  <TableCell key={account.id}>
                    {fraction === undefined
                      ? EN_DASH
                      : formatPercentValue(fraction)}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {!readOnly && (
        <Button
          type='button'
          variant='contained'
          onClick={() => onSave(placeholderPayload(report))}
        >
          {t('shared:save')}
        </Button>
      )}
    </>
  );
};
